import React, {  useEffect,  useState } from 'react';

import { useHistory } from "react-router-dom";
import { Facebook } from 'react-spinners-css';
import { useServices } from '../../hooks/useServices';
import { useEventos } from '../../hooks/useEventos';

export const ElijePago = ({cantidad, vigencia, lic1} ) => {

	const [cargando, setCargando] = useState(false);
	const [pagar, setPagar] = useState(false);
	const [botn, setBotn] = useState(false);
	const [codi, setCodi] = useState(false);
    const history = useHistory();
    const { getConsulta, getBotonPago, getCODI } = useServices();
	const { clicTiendas, clicPago } = useEventos();
  
	
	//console.log(' lic que viene: ', lic1);
	
	
  const handleClick = () => {
	clicTiendas();
    history.push("/locator");
  }

  const handleClick2 = () => {
	  if(codi){
		 lic1.singlePaymentMethod = "01"; 
	  }
	  clicPago('tarjeta');
    history.push("/load", {paymentSelfServiceRequest: lic1});
        //console.log('objeto lic enviado: ', lic1);
  }

  const handleClick3 = () => {
	  if(codi){
		  lic1.singlePaymentMethod = "02"; 
	  }
	  clicPago('codi');
    history.push("/load", {paymentSelfServiceRequest: lic1});
        //console.log('objeto lic enviado: ', lic1);
  }

	async function verBotonCodi(){
		let cod;
        const {value} = await getCODI(8);//7 es CODI ATT 8 es CODI UNEFON
		if(value == "0"){//0 es desactivado 1 es activado
			setCodi(false);
		}else{
			setCodi(true);
		}
    }

	async function verBotonPago(){
        const {enableButtonPayment} = await getBotonPago();
        if(enableButtonPayment ==1 ){//0 es activado, 1 es desactivado
            setBotn(true);
        }else{
            setBotn(false);
        }
    }


    
	useEffect(() => {
		verBotonPago();
		verBotonCodi();
		async function fetchInitialData() {
			
			const respuestaConsulta = await getConsulta();
			if (respuestaConsulta) {
				setCargando(true);
				if (typeof respuestaConsulta.status === 'number') {
					history.push("/error");
				} else {
					if (respuestaConsulta.status === "003") {
						setPagar(true);
					}
				}
			} else {
				history.push("/error");
				setCargando(true);
			}
		}
		setTimeout(() => { fetchInitialData() }, 3000);
	}, []);

    return (
		<div>
		{cargando?
			<>{pagar ?
				<>
					<div className="titulo">¡Felicidades, activaste tu promoción!</div>
					<p>Realiza tu recarga por <b>${cantidad}</b> antes del <b>{vigencia}</b> para recibir tu promoción.</p>
				</>
				: <p>Hubo un problema para activar tu oferta, espera unos minutos y recarga la página</p>
				}
			   <div className="botonera2">
	           
		            <div onClick={handleClick} className="btnpagotiendaM1 animate__animated animate__flipInX" >
					Localiza puntos de recarga
		                <div className="icoTienda"></div>
		            </div>

					{(pagar && botn) && 
					<>
						<div onClick={handleClick2} className="btnpagolineaM1 animate__animated animate__flipInX" >
							Recarga en línea
							<div className="icoLinea"></div>
						</div>	
					</>
					}
					{(pagar && botn && codi) && 
					<>
						<div onClick={handleClick3} className="btnpagolineaM2 animate__animated animate__flipInX" >
						Recarga con CODI
						<div className="icoQR"></div>
						</div>	
					</>
					}
           		</div>
				   <div className="legalRecarga">Recuerda que puedes realizar tu recarga en tu tienda favorita o en mi AT&T.</div>
	            <div className="overlayTotal">
	                <div className="totalPreview">
	                   <div>Pago Total:</div>
	                   <div>${cantidad}.00</div>
	                </div>
	            </div>
          </>  
          :<div className="spinner"><Facebook color="#594498"/></div>
		}
		</div>
    )
}
